var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rent-status-base',{attrs:{"title":_vm.title,"rent-statuses":_vm.rentStatuses}})}
var staticRenderFns = []

export { render, staticRenderFns }